module.exports = __webpack_public_path__ + "static/media/president-suite-img5.51fb3648.jpg";